<template>
  <div class="h-100 w-100 auth-layout d-flex justify-content-center">
    <!-- <div class='box'>
      <div></div>
      <div></div>
      <div></div>
    </div> -->
    <div class="area" >
      <ul class="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
    <div class="w-50 d-flex flex-column justify-content-center align-items-center">
      <b-container>
        <b-card class="w-100 auth-card">
          <b-card-header class="d-flex justify-content-center mt-2">
            <b-img-lazy v-if="GET_IS_DARK_MODE" :src="require('@/assets/images/VOIPLogo-white.svg')" height="50" @click.native="$router.push('/')" />
            <b-img-lazy v-else :src="require('@/assets/images/VOIP-Phone-Business-Logo.svg')" height="50" @click.native="$router.push('/')" />
          </b-card-header>
          <b-card-body>
            <router-view />
          </b-card-body>
        </b-card>
      </b-container>
    </div>
  </div>
</template>

<script>
import { GET_IS_DARK_MODE } from '@/store/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'AuthLayout',
  computed: {
    ...mapGetters([
      GET_IS_DARK_MODE
    ])
  },
}
</script>

<style lang="scss" scoped>
.dark-theme {
  .auth-layout {
    background-color: $dark;
    > .area {
      > .circles {
        > li {
          background: rgba(255, 255, 255, 0.2);
        }
      }
    }
    .auth-card {
      background-color: $dark-card;
    }
  }
}
.auth-layout {
  > .area {
    background: transparent;
    width: 100%;
    height: 100vh;
    position: absolute;
    > .circles {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      > li {
        position: absolute;
        display: block;
        list-style: none;
        width: 20px;
        height: 20px;
        background: rgba(0, 0, 0, 0.2);
        // background: rgba(85, 118, 209, 0.2);
        animation: animate 25s linear infinite;
        bottom: -150px;
        &:nth-child(1){
          left: 10%;
          width: 20px;
          height: 20px;
          animation-delay: 2s;
          animation-duration: 12s;
        }
        &:nth-child(2){
          left: 20%;
          width: 15px;
          height: 15px;
          animation-delay: 2s;
          animation-duration: 35s;
        }
        &:nth-child(3){
          left: 25%;
          width: 80px;
          height: 80px;
          animation-delay: 0s;
        }
        &:nth-child(4){
          left: 35%;
          width: 150px;
          height: 150px;
          animation-delay: 7s;
        }
        &:nth-child(5){
          left: 40%;
          width: 60px;
          height: 60px;
          animation-delay: 0s;
          animation-duration: 18s;
        }
        &:nth-child(6){
          left: 50%;
          width: 25px;
          height: 25px;
          animation-delay: 15s;
          animation-duration: 45s;
        }
        &:nth-child(7){
          left: 65%;
          width: 20px;
          height: 20px;
          animation-delay: 0s;
        }
        &:nth-child(8){
          left: 70%;
          width: 20px;
          height: 20px;
          animation-delay: 4s;
        }
        &:nth-child(9){
          left: 75%;
          width: 110px;
          height: 110px;
          animation-delay: 3s;
        }
        &:nth-child(10){
          left: 85%;
          width: 150px;
          height: 150px;
          animation-delay: 0s;
          animation-duration: 11s;
        }
      }
    }
  }
  .auth-card {
    background-color: $light-card;
  }
}
@keyframes animate {
  0%{
    transform: translateY(0) rotate(0deg);
    opacity: 1;
    border-radius: 0;
  }
  100%{
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 50%;
  }
}
</style>